import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.automatedLendingDecision.decisionError.duplicateGuarantorError.title',
        defaultMessage: "You haven't finished your affordability assessment"
    },
    message: {
        id: '_.automatedLendingDecision.decisionError.duplicateGuarantorError.message',
        defaultMessage:
            "We can't continue without it, so we'll be in touch shortly."
    }
});
